import React from "react";
import dompurify from "dompurify";
import "./Header.scss";
import { sanitizeOrPassthrough } from "../../helpers/rteHelpers";

const MegaMenuEditorialBlock = ({ editorialBlock }) => {
  return (
    <div className="flex flex-col w-full break-inside-avoid pb-[50px]">
      <div className="font-bold border-b border-blue-800 text-blue-800 py-1 flex flex-row">
        <span className="text-[20px]">{editorialBlock.title}</span>
      </div>
      <div
        className="text-[20px] editorial-block-content"
        dangerouslySetInnerHTML={{
          __html: sanitizeOrPassthrough(dompurify, editorialBlock?.text),
        }}
      />
    </div>
  );
};

export default MegaMenuEditorialBlock;